<script setup>
const props = defineProps({
  errors: {
    type: Array,
    default: () => [],
  },
  errorStyling: {
    type: Object,
    required: false,
    default() {
      return {
        ul: {},
        li: {},
      }
    },
  },
  suppressLabel: {
    type: Boolean,
    default: false,
    required: false,
  },
  useCloseButton: {
    type: Boolean,
    default: false,
    required: false,
  },
})
const label = computed(() => {
  if (props.suppressLabel) {
    return ''
  }
  return 'Error: '
})
const errorArray = computed(() => {
  if (typeof props.errors === 'string') {
    return [props.errors]
  }
  if (Array.isArray(props.errors)) {
    return props.errors
  }
  return []
})
</script>

<template>
  <ul v-if="errorArray.length" class="errorlist" :style="errorStyling.ul">
    <li
      v-for="error in errorArray"
      :key="error"
      class="error"
      :style="errorStyling.li"
    >
      <button v-if="useCloseButton" class="close">Close</button>
      {{ label }}{{ error }}
    </li>
  </ul>
</template>
